import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, matchPath } from 'react-router-dom';
import { profileFetchIfNeeded, profileUpdateStages, profileFetch } from './../store/profile/actions';
import { get, isEmpty } from 'lodash';
import { clearValue } from './../utils/keyStorage';
import { VERSION } from '../constants/version';
import { SHORT_SUBJECT_TYPE } from '../constants/subjectTypes';
import stages from '../constants/stages';
import stages_v8 from '../constants/stages_v8';
import stages_v9 from '../constants/stages_v9';
import profileStatuses from '../constants/profileStatuses';
import profileStages from '../constants/profileStages';
import { trackValues } from './../tracker';
import { trackSiteId } from './../config';
import LRPixel from './LRPixel';
import { googleMeasurementSecret } from './../utils/gaUtils';

const stagesForTrackerGAMeasurement = ['language_test_success', 'subject_test_success', 'sandbox_completed']

class LoginContainer extends Component {
  componentDidMount() {
    const { loadProfile, isAuthenticated, userId } = this.props;
    if (isAuthenticated) {
      window.dataLayer.push({ 'userID': userId.toString() });
    }
    loadProfile();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.didInvalidate && this.props.didInvalidate) {
      this.props.loadProfile();
    }

    if (!prevProps.isAuthenticated && this.props.isAuthenticated) {
      window.dataLayer.push({ 'userID': this.props.userId.toString() });
    }

    if (this.props.profileStage === profileStages.PHONE_VERIFICATION && !this.props.isFetching && prevProps.isFetching) {
      if (!this.props.languagePassingScore && !this.props.languageTestScore) {
        this.props.forceLoadProfile();
      }
      if (this.props.languagePassingScore && this.props.languageTestScore) {
        this.onTrackerData();
      }
    } else {
      if (prevProps.profileStage !== this.props.profileStage && !this.props.isFetching) {
        this.onTrackerData();
      }
    }

    if (prevProps.isFetching && !this.props.isFetching) {
      if (typeof this.props.profileStage === 'string' && !!this.props.profileStage) {
        if (this.props.profileStage !== 'academic_test') {
          clearValue('atstp');
          clearValue('atddl');
          clearValue('atscr');
        }
      }
      this.checkRoute();
    }
  }

  onTrackerData() {
    const { version, userId, majorSubject, languagePassingScore, languageTestScore, subjectPassingScore, subjectTestScore } = this.props;
    let { profileStage } = this.props;

    if (stagesForTrackerGAMeasurement.includes(profileStage)) {
      googleMeasurementSecret({ event: profileStage, userId })
    }

    const data = { userId, version, site_id: trackSiteId }
    if (!isEmpty(profileStage)) {

      if (profileStage === profileStages.APPLICANT_FIRST_PREFERRED_SUBJECT ||
        profileStage === profileStages.APPLICANT_INFO_SECOND_SUBJECTS) {
        return null;
      }
      if (!isEmpty(majorSubject) && majorSubject !== 'default') {
        data.preferredSubject = SHORT_SUBJECT_TYPE[majorSubject]
      }

      if (profileStage === profileStages.PHONE_VERIFICATION) {
        if (!this.props.languagePassingScore && !this.props.languageTestScore) {
          return null;
        }
        if (this.props.languagePassingScore && this.props.languageTestScore) {

          trackValues('language_test_end', true, {
            context: { ...data, languagePassingScore, languageTestScore },
          });

          if (this.props.languageTestScore >= this.props.languagePassingScore) {
            profileStage = 'language_test_success';
            const isGenerateEvent = localStorage.getItem('_ga_set_language_test');
            if (!isGenerateEvent) {
              googleMeasurementSecret({ event: profileStage, userId });
              localStorage.setItem('_ga_set_language_test', true);
            }

            trackValues('stage', profileStage, {
              context: data,
            });
          }

          profileStage = 'phone_verification';
          trackValues('stage', profileStage, {
            context: { userId, version, site_id: trackSiteId },
          });
          return;
        }
      }

      if (profileStage === profileStages.SUBJECT_TEST_FAILED ||
        profileStage === profileStages.SUBJECT_TEST_SUCCESS) {
        if (subjectPassingScore && subjectTestScore) {
          trackValues('subject_test_end', true, {
            context: { ...data, subjectPassingScore, subjectTestScore },
          });
        }
      }

      if (profileStage === profileStages.SUBJECT_ESSAY_1) {
        profileStage = 'test_task';
      }

      if (profileStage === profileStages.LANGUAGE_TEST_FAILED) {
        data.languagePassingScore = languagePassingScore
        data.languageTestScore = languageTestScore
        trackValues('language_test_end', true, {
          context: data,
        });
      }

      trackValues('stage', profileStage, {
        context: data,
      });

    }
  }

  checkRoute() {
    const { isAuthenticated, location, history, profileStage, profileStatus, hasTest, nextStage, useVpn, version } = this.props;
    const isNotCurrentRoute = to => to.every(t => !matchPath(location.pathname, { path: to }));
    const authorizedRoutes = isNotCurrentRoute(['/login', '/login/:token', '/registration', '/password-recovery', '/test', '/demo', '/test_orders'])

    if (!isAuthenticated && authorizedRoutes) {
      history.replace('/login');
      return;
    }

    if (isAuthenticated && useVpn) {
      history.replace('/vpn');
      return;
    }

    if (profileStatus === profileStatuses.DELETED ||
      profileStatus === profileStatuses.OUTDATED ||
      profileStatus === profileStatuses.SANCTIONED) {
      history.replace('/sorry');
      return;
    }

    if (profileStage === profileStages.APPLICANT_INFO) {
      history.replace('/applicant-info');
      return;
    }

    if (profileStage === profileStages.APPLICANT_INFO_MAJOR_SUBJECTS) {
      history.replace('/preferred-subjects');
      return;
    }

    if (profileStage === profileStages.APPLICANT_FIRST_PREFERRED_SUBJECT) {
      history.replace('/preferred-subjects');
      return;
    }

    if (profileStage === profileStages.APPLICANT_INFO_SECOND_SUBJECTS) {
      history.replace('/preferred-subjects-other');
      return;
    }

    if (profileStage === 'essay_welcome') {
      nextStage();
      return;
    }

    if (profileStage === profileStages.LANGUAGE_TEST_FAILED && version !== VERSION.v8 && version !== VERSION.v9) {
      if (hasTest) {
        history.replace('/language-test/failed');
        return;
      }
    }

    if (profileStage === profileStages.LANGUAGE_TEST_FAILED && (version === VERSION.v8 || version === VERSION.v9)) {
      history.replace('/application-overview');
      return;
    }

    if (profileStage === profileStages.SUBJECT_TEST_FAILED && (version === VERSION.v8 || version === VERSION.v9)) {
      if (hasTest) {
        history.replace('/application-overview');
        return;
      }
    }

    if (profileStatus === profileStatuses.HIRED) {
      history.replace('/congratulations');
      return;
    }

    if (profileStatus === profileStatuses.MEETING) {
      history.replace('/congratulations');
      return;
    }

    if (profileStatus === profileStatuses.HIDDEN) {
      history.replace('/sorry');
      return;
    }

    if (profileStage === 'language_test') {
      if (hasTest) {
        history.replace('/language-test');
        return;
      }
    }

    if (location.pathname === '/repeat-tutorial') {
      return;
    }

    let replacePath = version === VERSION.v8 ? stages_v8[profileStage] : stages[profileStage];
    if (version === VERSION.v9) {
      replacePath = stages_v9[profileStage];
    }
    if (isAuthenticated && ['/restore-password'].indexOf(location.pathname) <= -1 && replacePath) {
      history.replace(replacePath);
    }
  }

  render() {
    const { children } = this.props;

    return (
      <div>
        <LRPixel />
        {children}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const profileState = state.profile;
  const isFetching = get(profileState, 'isFetching')
  const { didInvalidate, error, data } = profileState;
  const userId = get(data, 'user.id', false);
  const isAuthenticated = !!userId;
  const profileStage = get(data, 'user.stage', {});
  const profileStatus = get(data, 'user.status', {});
  const majorSubject = get(data, 'user.profile.subject_type', {});
  const languagePassingScore = get(data, 'user.profile.language_passing_score', 0);
  const languageTestScore = get(data, 'user.profile.language_test_score', 0);
  const subjectPassingScore = get(data, 'user.profile.subject_passing_score', 0);
  const subjectTestScore = get(data, 'user.profile.subject_test_score', 0);
  const version = get(data, 'user.scenario_version', 'v0');
  const useVpn = get(data, 'user.profile.is_anonymous', {});
  const hasTest = get(state.test, 'testSteps', []).length > 0

  return {
    isFetching,
    profileStage,
    profileStatus,
    didInvalidate,
    error,
    isAuthenticated,
    hasTest,
    userId,
    useVpn,
    version,
    majorSubject,
    languagePassingScore,
    languageTestScore,
    subjectPassingScore,
    subjectTestScore,
    profileState,
  };
};

const mapDispatchToProps = dispatch => ({
  loadProfile: () => dispatch(profileFetchIfNeeded()),
  forceLoadProfile: () => dispatch(profileFetch()),
  nextStage: data => (dispatch(profileUpdateStages(data))),

});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginContainer));



// WEBPACK FOOTER //
// ./src/components/LoginContainer.js